import React from 'react';
import { Container } from 'react-bootstrap';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            return (
                <Container className="py-5 text-center">
                    <div style={{ fontSize: '64px', marginBottom: '16px' }}>🐝</div>
                    <h2 className="fw-bold mb-3">Etwas ist schiefgelaufen</h2>
                    <p className="text-muted mb-4">
                        Ein unerwarteter Fehler ist aufgetreten. Bitte lade die Seite neu.
                    </p>
                    <button
                        onClick={() => window.location.reload()}
                        className="btn btn-lg px-5 py-3"
                        style={{
                            background: '#222',
                            color: '#fff',
                            borderRadius: '12px',
                            fontWeight: '600'
                        }}
                    >
                        Seite neu laden
                    </button>
                </Container>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
